<template>
	<div class="template-order">
		<van-nav-bar class="custom-nav-bar" :title="$t('recharge.records_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="tab-container">
			<div class="tab_list">
				<div
					v-for="tab in tabs"
					:key="tab.status"
					class="tab_li"
					:class="{ active_s: activeStatus === tab.status }"
					@click="changeTab(tab.status)"
				>
					{{ tab.label }}
				</div>
			</div>
		</div>
		<div class="page-content">
			<div v-if="filteredList.length" class="recharge-list">
				<div
					v-for="item in filteredList"
					:key="item.id || item.order_no"
					class="recharge-item"
				>
					<div class="recharge-item__head">
						<div class="recharge-item__head__title">订单号:{{ item.order_no || '--' }}</div>
						<div class="recharge-item__head__amount">€{{ formatAmount(item.money) }}</div>
					</div>
					<div class="recharge-item__body">
						<div class="recharge-item__body__row">
							<div class="recharge-item__body__label">{{ $t('common.status') }}</div>
							<div class="recharge-item__body__status">
								<span class="status-text" :class="formatStatusClass(item.status)">
									{{ formatStatusText(item.status) }}
								</span>
							</div>
						</div>
						<div class="recharge-item__body__row">
							<div class="recharge-item__body__label">{{ $t('common.submit_time') }}</div>
							<div class="recharge-item__body__time">{{ item.create_time || '--' }}</div>
						</div>
						<div class="recharge-item__body__row">
							<div class="recharge-item__body__label">{{ $t('common.review_time') }}</div>
							<div class="recharge-item__body__time">{{ formatAuditTime(item) }}</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="recharge-list">
				<div class="empty-state">
					<div class="empty-icon">
						<span class="tn-icon-income tn-color-gray--light"></span>
					</div>
					<div class="empty-text">
						{{ $t('common.no_content') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				list: [],
				tabs: [{
					label: this.$t("common.in_review"),
					status: 1
				}, {
					label: this.$t("common.completed"),
					status: 2
				}, {
					label: this.$t("common.rejected"),
					status: 3
				}],
				activeStatus: 1
			};
		},
		computed: {
			filteredList() {
				return this.list.filter((item) => Number(item.status) === this.activeStatus);
			}
		},
		methods: {
			back() {
				return window.history.back();
			},
			changeTab(status) {
				this.activeStatus = status;
			},
			formatAmount(value) {
				const amount = parseFloat(value);
				return Number.isNaN(amount) ? "0.00" : amount.toFixed(2);
			},
			formatStatusText(status) {
				const statusMap = {
					1: this.$t("common.in_review"),
					2: this.$t("common.completed"),
					3: this.$t("common.rejected"),
				};
				return statusMap[Number(status)] || this.$t("recharge.unknown_status");
			},
			formatStatusClass(status) {
				const classMap = {
					1: "status-pending",
					2: "status-success",
					3: "status-rejected"
				};
				return classMap[Number(status)] || "status-pending";
			},
			formatAuditTime(item) {
				return Number(item.status) === 1 ? this.$t("recharge.pending_review") : (item.update_time || this.$t(
					"recharge.pending_review"));
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.isLoading = false;
					this.getRechargeList(); // 刷新时重新加载
				}, 500);
			},
			getRechargeList() {
				this.$http({
					method: 'get',
					url: "user_get_recharge_list"
				}).then(res => {
					if (res.code === 200) {
						this.list = Array.isArray(res.data) ? res.data : [];
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				}).catch(() => {
					this.$toast(this.$t("recharge.list_load_failed"));
				});
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				});
			} else {
				this.getRechargeList();
			}
		}
	};
</script>

<style lang='less' scoped>
	/* 页面容器 */
	.template-order {
		background-color: #f5f5f5;
		min-height: 100vh
	}

	/* 页面内容 */
	.page-content {
		padding: 10px 20px;
	}

	/* 导航栏返回按钮 */
	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 100px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 标签容器 */
	.tab-container {
		/* position: fixed;
		left: 0;
		right: 0; */
		width: 100%;
		background-color: #fff;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
		z-index: 999
	}

	/* 标签列表 */
	.tab_list {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		padding: 7px 10px
	}

	.tab_list .tab_li {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		color: #333;
		padding: 4px 8px;
		border-bottom: 1px solid transparent;
		transition: all .3s ease
	}

	.tab_list .active_s {
		color: #1f77d5;
		border-bottom: 1px solid #1f77d5;
		font-weight: 600
	}

	/* 充值记录列表 */
	.recharge-list {
		padding-bottom: 20px
	}

	/* 充值记录项 */
	.recharge-item {
		margin-top: 10px;
		padding: 12px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
		-webkit-animation: fadeInUp-data-v-88541c92 .5s ease forwards;
		animation: fadeInUp-data-v-88541c92 .5s ease forwards;
		opacity: 0;
		-webkit-transform: translateY(10px);
		transform: translateY(10px)
	}

	.recharge-item:first-child {
		margin-top: 0
	}

	.recharge-item__head {
		margin-bottom: 8px
	}

	.recharge-item__head__title {
		font-size: 12px
	}

	.recharge-item__head__amount {
		font-size: 16px;
		color: #1f77d5
	}

	.recharge-item__body__time {
		font-size: 12px;
		color: #333;
		text-align: right
	}

	.recharge-item__body {
		display: flex;
		flex-direction: column;
		gap: 8px
	}

	.recharge-item__body__row {
		display: flex;
		align-items: center;
		justify-content: space-between
	}

	.recharge-item__body__label {
		font-size: 12px;
		color: #999
	}

	.recharge-item__body__status .status-text {
		font-size: 10px;
		padding: 2px 8px;
		border-radius: 6px
	}

	.recharge-item__body__status .status-pending {
		color: #ff9500;
		background-color: rgba(255, 149, 0, .1)
	}

	.recharge-item__body__status .status-success {
		color: #4cd964;
		background-color: rgba(76, 217, 100, .1)
	}

	.recharge-item__body__status .status-rejected {
		color: #ff3b30;
		background-color: rgba(255, 59, 48, .1)
	}

	/* 空状态 */
	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 52px 0
	}

	.empty-state .empty-icon {
		font-size: 62px;
		margin-bottom: 12px
	}

	.tn-color-gray--light {
		color: #f8f7f8 !important;
	}

	.empty-state .empty-text {
		font-size: 12px;
		color: #e6e6e6 !important;
		text-align: center;
	}

	/* 动画 */
	@-webkit-keyframes fadeInUp-data-v-88541c92 {
		from {
			opacity: 0;
			-webkit-transform: translateY(10px);
			transform: translateY(10px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	@keyframes fadeInUp-data-v-88541c92 {
		from {
			opacity: 0;
			-webkit-transform: translateY(10px);
			transform: translateY(10px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}
</style>
